import { ValidationProvider, ValidationObserver } from "vee-validate";
import mixins from "vue-typed-mixins";
import changePersonalEmailMixin from "./changePersonalEmailMixin";
import { getAccountType, maskEmail } from "./helpers";
import faqMixin from "./faqMixin";
import { Collapsible, Card, TextField, Button, Icon, Alert as VAlert, Accordion, } from "@/components";
import { featureToggleMixin, gtmMixin } from "@/mixins";
const CardHeader = () => import("./CardHeader.vue");
const CardStep = () => import("./CardStep.vue");
const PhoneDetail = () => import("./PhoneDetail.vue");
const ButtonSendDetail = () => import("./ButtonSendDetail.vue");
const ValidationError = () => import("@/components/ValidationError.vue");
export default mixins(changePersonalEmailMixin, faqMixin, gtmMixin, featureToggleMixin).extend({
    components: {
        Card,
        TextField,
        Accordion,
        Icon,
        Button,
        CardHeader,
        CardStep,
        ValidationProvider,
        ValidationObserver,
        ValidationError,
        VAlert,
        ButtonSendDetail,
        PhoneDetail,
        Collapsible,
    },
    props: {
        alert: {
            type: Object,
            default: () => ({
                message: "",
                type: "",
            }),
        },
        email: {
            type: String,
            default: "",
        },
        submittingEmail: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        personalEmail: "",
        isEmailReadonly: true,
        showAlert: false,
        disableButtonSend: false,
    }),
    computed: {
        isPtk() {
            return getAccountType() === "ptk";
        },
        isPd() {
            return getAccountType() === "pd";
        },
        howToActivate() {
            return `Operator Sekolah bisa mendapatkan Akun Pembelajaran dengan cara berikut:
1. Buka laman http://pd.data.kemdikbud.go.id/
2. Login menggunakan akun SSO Data Pokok Pendidikan (Dapodik) dimana akun terdaftar di http://sdm.data.kemdikbud.go.id

3. Klik tombol “**Unduh Akun**”, pilih “**Peserta Didik**” atau “**PTK**” untuk mengunduh data dengan format .csv berisi nama akun (*User ID*) dan akses masuk kata sandi akun (*password*)

4. Buka data dengan format .csv yang sudah diunduh, lalu berikan informasi akun (*User ID* dan kata sandi atau *password*) kepada pengguna. Pastikan informasi hanya diberikan kepada pemilik resmi akun sesuai data di Data Pokok Pendidikan (Dapodik).
    `;
        },
        isEmailChanged() {
            return !!this.personalEmail && this.personalEmail !== this.email;
        },
        disableButtonSendDetail() {
            return (this.submittingEmail ||
                !this.personalEmail ||
                this.loading ||
                this.disableButtonSend);
        },
    },
    watch: {
        email: {
            immediate: true,
            handler(val) {
                this.personalEmail = val;
            },
        },
        submittingEmail(val) {
            if (val) {
                setTimeout(() => {
                    this.$emit("alert:hide");
                }, 30 * 1000);
            }
        },
        alert: {
            deep: true,
            handler(val) {
                if (Object.values(val).some((v) => !!v)) {
                    this.showAlert = true;
                    setTimeout(() => {
                        this.showAlert = false;
                        this.$emit("alert:hide");
                    }, 10 * 1000);
                }
                else {
                    this.showAlert = false;
                }
            },
        },
    },
    methods: {
        onEmailFocus() {
            var _a;
            this.personalEmail = "";
            this.isEmailReadonly = false;
            this.disableButtonSend = true;
            (_a = this.$refs.inputEmail) === null || _a === void 0 ? void 0 : _a.focus();
        },
        async changeEmail() {
            const emailRef = this.$refs.emailRef;
            const status = await emailRef.validate();
            const isInvalidEmail = this.personalEmail.includes("*");
            if (isInvalidEmail)
                return;
            if (status.valid && this.isEmailChanged) {
                this.alert.type = "";
                this.alert.message = "";
                if (this.loading)
                    return;
                await this.changePersonalEmail(this.personalEmail);
                if (this.error) {
                    this.showAlert = true;
                    this.alert.type = "error";
                    this.alert.message = this.error;
                }
                else if (this.success) {
                    this.$emit("email:change");
                    this.alert.type = "success";
                    this.alert.message = "Email berhasil diubah";
                    this.personalEmail = maskEmail(this.personalEmail);
                    this.disableButtonSend = false;
                    this.isEmailReadonly = true;
                    setTimeout(() => {
                        this.success = false;
                    }, 10000);
                }
            }
            else {
                this.personalEmail = this.email;
                this.disableButtonSend = false;
                emailRef.reset();
            }
        },
        sendDetailToEmail() {
            this.$emit("sendDetail");
            this.gtmClickButton("kirim_detail_akun", {
                query_position: this.personalEmail,
            });
        },
        sendDetailToPhone() {
            this.$emit("sendDetail:phone");
            // this.gtmClickButton("kirim_detail_akun", {
            //   query_position: this.personalEmail,
            // });
        },
    },
});
